import React from 'react';
import { OrdersToShipView } from './OrdersToShipView';

export const ShippingPlanning: React.FC = () => (
    <OrdersToShipView ordersWithAssignShipping={false} />
);
